export * from './ActorQueryOperationMinus';
